/* Policy-page (/policies/*) content normalizer — pairs with policy.css.
   The four policy bodies are authored as loose rich text in the admin
   (Settings -> Policies) and can't be edited from the theme, so this pass
   gives them one document structure: it strips empty rich-text leftovers,
   upgrades paragraphs whose entire text is a single <strong>/<b> run (the
   Refund and Terms pseudo-headings) to real <h2>s, and title-cases the
   sentence-case h1 Shopify emits ("Refund policy" -> "Refund Policy").
   policy.css keys its no-JS fallback rules off the .policy-normalized
   class set at the end. */
(function () {
  var rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  var heading = document.querySelector('.shopify-policy__title h1');
  if (heading) {
    heading.textContent = heading.textContent.replace(/[A-Za-z]+/g, function (word, offset) {
      if (offset > 0 && /^(of|and|or|the|an?|to|in|on|for)$/i.test(word)) return word.toLowerCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  }

  rte.querySelectorAll('h1, h2, h3, h4, h5, h6, p, ul, ol').forEach(function (el) {
    // trim() strips &nbsp; (U+00A0) too — it's ECMAScript WhiteSpace
    if (!el.textContent.trim() && !el.querySelector('img, iframe, embed, table')) el.remove();
  });

  rte.querySelectorAll('p').forEach(function (p) {
    var only = p.children.length === 1 ? p.children[0] : null;
    if (!only || (only.tagName !== 'STRONG' && only.tagName !== 'B')) return;
    if (only.textContent.trim() !== p.textContent.trim()) return;
    var h = document.createElement('h2');
    h.innerHTML = only.innerHTML;
    p.replaceWith(h);
  });

  rte.classList.add('policy-normalized');
})();
